import easyxdm from 'easyxdm';
export default class EqsForm {
    static init()
    {
        const walls = document.querySelectorAll('.eqs-form-wrapper');
        walls.forEach(el => {
            new EqsForm(el);
        })
    }

    constructor(el)
    {
        this.element = el;
        const contentElement = this.element.querySelector('.eqs-form');
        if (contentElement) {
            this.loadScript(contentElement);
        }
        // It can happen, that a user revokes and re-applies the consent, thus we need to observe if the content element comes back
        this.onCookieConsentAccepted((contentElement) => {
            this.loadScript(contentElement);
        });
    }

    onCookieConsentAccepted(callback)
    {
        let config = { attributes: false, childList: true, subtree: true };
        let mutationObserverCallback = (mutationsList) => {
            for(let mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if(node.nodeType === Node.ELEMENT_NODE) {
                            if(node.classList.contains('eqs-form')) {
                                callback(node);
                            }
                        }
                    });
                }
            }
        };
        let observer = new MutationObserver(mutationObserverCallback);
        observer.observe(this.element, config);
    }

    loadScript(contentElement)
    {
        new easyxdm.Socket({
            remote: contentElement.dataset.remoteUri,
            container: contentElement.getAttribute('id'),
            onMessage: function (message, origin) {
                const height = parseInt(message) + 40;
                this.container.getElementsByTagName('iframe')[0].style.height = height + 'px';
                this.container.getElementsByTagName('iframe')[0].scrolling = 'no';
            }
        });
    }
}
